import { api } from './client';

export interface OffsetDto {
  id: number;
  date: string;
  documentNumber: string;
  content: string;
  accountDebit: number;
  accountCredit: number;
  amount: number;
  currencyCode: string;
  personId: number | null;
}

export interface CreateOffsetRequest {
  date: string;
  documentNumber: string;
  content: string;
  accountDebit: number;
  accountCredit: number;
  amount: number;
  personId?: number | null;
  currencyCode?: string;
  currencyRate?: number;
  autoSerialCode?: string;
}

export const offsetsApi = {
  list: (params: { from?: string; to?: string } = {}) =>
    api.get<OffsetDto[]>('/offsets', {
      from: params.from,
      to: params.to,
    }),

  getById: (id: number) =>
    api.get<OffsetDto>(`/offsets/${id}`),

  create: (data: CreateOffsetRequest) =>
    api.post<number>('/offsets', data),

  update: (id: number, data: CreateOffsetRequest) =>
    api.put<void>(`/offsets/${id}`, data),

  delete: (id: number) =>
    api.delete<void>(`/offsets/${id}`),
};
